import clsx from 'clsx';
import { LabeledInput } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';


import css from '../EintragungenFilter.module.scss';

import PremiumCta from './PremiumCta';


const UnternehmensDetailsuche: React.FC = () => 
{
  const { t } = useTranslation(['common', 'bundesländer', 'eintragungen']);

  const bundesländer = t('bundesländer:list', { returnObjects: true }) as string[];

  const inputs =
    (<div>
      <LabeledInput
        id="bundesland"
        label={t('eintragungen:filter.bundesland')}
      >
        <select>
          <option value="">{t('search:wizard.actions.select')}</option>
          {Object.entries(bundesländer).map(([key, value]) => (
            <option disabled key={key}>{value}</option>
          ))}
          <option disabled>{'------'}</option>
          <option disabled>{t('bundesländer:Ausland')}</option>
        </select>
      </LabeledInput>
      <LabeledInput
        id="datum"
        label={t('eintragungen:filter.limit.label')}
      >
        <select>
          <option>{t('eintragungen:filter.limit.lastN', { n: 3 })}</option>
          <option disabled>{t('eintragungen:filter.limit.lastN', { n: 15 })}</option>
          <option disabled>{t('eintragungen:filter.limit.lastN', { n: 30 })}</option>
          <option disabled>{t('eintragungen:filter.limit.lastN', { n: 50 })}</option>
          <option disabled>{t('eintragungen:filter.limit.lastN', { n: 100 })}</option>
          <option disabled>{t('eintragungen:filter.limit.all')}</option>
        </select>
      </LabeledInput>
    </div>);

  return (
    <div className={clsx([css.container, css.plusContainer])}>
      <form
        className={css.form}
      >
        <div className={css.cta}>
          <PremiumCta
            formField={inputs}
          />
        </div>
      </form>
    </div>
  );
};

export default UnternehmensDetailsuche;
